import { concat, Observable, of } from 'rxjs';
import { Dispatchable } from 'state/state.common';
import { WorkspaceType } from 'state/workspaces/model';
import { workspaceTabFrozen, workspaceTabUnfrozen } from 'state/workspaces/workspace.actions';

export function withTabFreeze(
  result$: Observable<Dispatchable>,
  tabId: string,
  workspace: WorkspaceType,
): Observable<Dispatchable> {
  return concat(
    of(workspaceTabFrozen(tabId, workspace, undefined)),
    result$,
    of(workspaceTabUnfrozen(tabId, workspace, undefined)),
  );
}
